// extracted by mini-css-extract-plugin
export default {"aside":"Aside_aside__aQvEo","box":"Aside_box__gJ5gO","icon":"Aside_icon__tu5V2","text":"Aside_text__3qzzh"};